<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12 mt-4">
          <h1>{{ $t('STUDIO.LABELS.MY_STUDIOS') }}</h1>
        </div>
      </div>
      <div v-if="isLoading" class="w-100 text-center pt-5">
        <HMSpinner />
      </div>
      <div class="row mt-4" v-if="!isLoading && recentStudios">
        <div
          v-for="studio in recentStudios"
          :key="studio.id"
          class="col-sm-6 col-md-4 col-lg-3 p-3"
        >
          <a
            class="text-center border rounded d-block undecorated-router-link"
            :href="getStudioURL(studio.studio_url)"
          >
            <img
              v-if="studio.logo"
              :src="studio.logo.storage_url"
              alt=""
              class="studio-card p-2"
            />
            <div v-else class="studio-card-no-logo p-2">
              {{ studio.studio_name }}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import HMSpinner from '@/web/components/common/HMSpinner';
import { isOfficialDomain, replaceURLWithCurrentDomain } from '@/web/utils/url';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioList',
  components: { HMSpinner },
  computed: {
    ...mapGetters({
      recentStudios: 'studio/recentStudios',
      studentMagicCode: 'user/studentMagicCode',
    }),
    getBaseFrontendURL() {
      const host = window.location.host.toLowerCase();
      if (isOfficialDomain(host)) {
        return replaceURLWithCurrentDomain(window.location.origin);
      }

      return process.env.VUE_APP_FRONTEND_BASE_URL;
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    getStudioURL(studioUrl) {
      return getStudentViewURL(studioUrl, '/', this.studentMagicCode, true);
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('studio/getRecentStudios');
      this.isLoading = false;
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('STUDIO.NOTIFICATIONS.LOAD_STUDIO_LIST_ERROR'),
        text: `Error: ${error}`,
        duration: -1, // stay ON
      });
    }
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.studio-card {
  height: 120px;
  width: 75%;
  object-fit: contain;
  overflow: hidden;
}
.studio-card-no-logo {
  height: 120px;
  width: 100%;
  object-fit: contain;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>
